import { actionCreatorFactory } from "typescript-fsa";

export interface CurrentUser {
  id: number;
  name: string;
  occupation_type: string | null;
  working_company_ids: number[];
}

export interface CurrentCompany {
  id: number;
  name: string;
  company_name: string;
}

export type Country = string; // TODO(stomk): Enumerate like "japan" | "united_stated", etc.

export interface BootstrapAuthData {
  current_user: CurrentUser | null;
  current_company: CurrentCompany | null;
  current_country: Country;
  locale: string;
}

const actionCreator = actionCreatorFactory("AUTH");

export const authInitiated = actionCreator<BootstrapAuthData>("INITIATED");



// WEBPACK FOOTER //
// ./frontend/src/common/actions/Auth.ts